import BaseAction from './BaseAction.js';
import {loadCompleteTrackJson} from 'engine/json/loadTrackJson.js';

class LoadProjectTracks extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    execute({
        tracks,
        patternToLoad
    }) {
        let promises = [];
        let numPatterns = 1;
        if (this.sequencerEngine.tracks.length > 0) {
            numPatterns = this.sequencerEngine.tracks[0].patterns.length;
        }

        // load the modulators
        this.sequencerEngine.loadLFOsAndEnvelopes(tracks[0]);
        
        for (let track of tracks) {
            promises.push(loadCompleteTrackJson({
                ... track,
                subSequence: this.sequencerEngine.currentSubSequence,
                sequencerEngine: this.sequencerEngine,
                tracks: this.sequencerEngine.tracks,
                numPatterns,
                patternToLoad
            }));
        }

        let engine = this.sequencerEngine;
        Promise.all(promises).then(
            tracks => {
                let group = engine.groups.newGroup();
                tracks.forEach(_track => {
                    let trackNumber = engine.tracks.length;
                    engine.setupNewTrack(_track, undefined, true, false);
                    _track.setupEffects();
                    _track.trackNumber = trackNumber;
                    group.addTrack(_track);
                });
                engine.updateTracks(true);
            });

        return {
            addedTracks: promises
        };
    }

    undo({payload}) {
        Promise.all(payload.addedTracks)
            .then(tracks => {
                this.sequencerEngine.deleteTracks(tracks);
                this.sequencerEngine.updateTracks();
            });
    }
}

export default LoadProjectTracks;
